<template>
  <div>
    <div class="list-group">
      <v-card
        tile
        height="100vh"
        max-height="calc(100% - 120px)"
        width="240"
        class="rounded-0 elevation-0"
      >
        <div class="list-group-title">Блоки выбора</div>

        <v-navigation-drawer permanent>
          <v-list-item-group
            color="var(--app-dark-blue-1)"
            v-model="selectedTicker"
            style="top: 8px"
          >
            <v-list-item
              dense
              :key="index"
              style="height: 48px"
              v-for="(item, index) in items"
            >
              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-navigation-drawer>
      </v-card>
    </div>
    <div class="component" v-if="typeof selectedTicker == 'number'">
      <component
        @goToEdit="goToEdit"
        @goToDetail="goToDetail"
        @goToPage="goToPage"
        v-bind:is="items[selectedTicker].content"
      ></component>
    </div>
  </div>
</template>

<script>
import DetailDocuments from "./SelectionPages/Documents/DetailDocuments";
import EditDocuments from "./SelectionPages/Documents/EditDocuments";

import DetailAboutElections from "./SelectionPages/MoreAboutElections/DetailAboutElections.vue";
import EditAboutElections from "./SelectionPages/MoreAboutElections/EditAboutElections.vue";

import DetailReception from "./SelectionPages/InternetReception/DetailReception.vue";
import SettingsReception from "./SelectionPages/InternetReception/SettingsReception.vue";
import EditReception from "./SelectionPages/InternetReception/EditReception.vue";

import EditQuestion from "./SelectionPages/InternetReception/EditDetailView/EditQuestion.vue";
import EditAnswer from "./SelectionPages/InternetReception/EditDetailView/EditAnswer.vue";
import EditComment from "./SelectionPages/InternetReception/EditDetailView/EditComment.vue";

import DetailVote from "./SelectionPages/Votes/DetailVote";
import EditVote from "./SelectionPages/Votes/EditVote";

export default {
  name: "SelectionBlocks",
  components: {
    DetailDocuments,
    EditDocuments,
    DetailAboutElections,
    EditAboutElections,
    DetailReception,
    SettingsReception,
    EditReception,
    EditQuestion,
    EditAnswer,
    EditComment,
    DetailVote,
    EditVote,
  },

  data: () => ({
    selectedTicker: 0,
    items: [
      {
        title: "Подробнее о выборах",
        content: "DetailAboutElections",
      },
      {
        title: "Документы",
        content: "DetailDocuments",
      },
      {
        title: "Интернет приемная",
        content: "DetailReception",
      },
      {
        title: "Голосование",
        content: "DetailVote",
      },
    ],
  }),

  created() {
    if (this.$route.params.selectedTicker) {
      this.selectedTicker = this.$route.params.selectedTicker;
    }
  },

  methods: {
    goToEdit() {
      const currentItem = this.items[this.selectedTicker];
      if (currentItem.content.includes("Detail")) {
        currentItem.content = currentItem.content?.replace("Detail", "Edit");
      }
    },
    goToDetail() {
      const currentItem = this.items[this.selectedTicker];
      if (currentItem.content.includes("Edit")) {
        currentItem.content = currentItem.content?.replace("Edit", "Detail");
      }
    },
    goToPage(page) {
      const currentItem = this.items[this.selectedTicker];
      currentItem.content = page;
    },
    getElection() {
      this.$axios
        .get(
          this.$store.getters.apiAdminPanelV5 +
            "/reception-of-candidates/actual",
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
              "secret-key": this.$store.state.secretKeyCookie,
            },
          }
        )
        .then((res) => {
          localStorage.setItem("electionId", res.data.id); //temporary decision to store election id
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
  },
  watch: {},
  mounted() {
    this.getElection();
  },
};
</script>
<style scoped>
.v-list-item__title {
  font-size: 1rem;
}

.list-group {
  position: fixed;
  display: block;
  margin: 0;
  padding: 0;
  width: 240px;
  max-width: 240px;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 1;

  color: #f8f8f8;
}

.component {
  position: absolute;
  left: 240px;
  width: calc(100% - 240px);
}

.list-group-title {
  font-size: 28px;
  font-weight: 400;
  box-sizing: border-box;
  padding-top: 34px;
  padding-left: 14px;
  border-right: 1px solid rgba(0, 0, 0, 0.15);
}
</style>
